// extracted by mini-css-extract-plugin
module.exports = {"OrderItemWrapper":"styles_OrderItemWrapper__1KXd7","OrderItemDescription":"styles_OrderItemDescription__ePPLL"};